export class ShareTracking {
    // staff
    share;

    constructor() {
        this.init();
    }

    init() {
        this.share = $('.share-site, .share-tool, .share-section, .share-aperture');

        if (!this.share.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.share.on('click', 'a', (e) => {
            const button = $(e.target);

            this.sendGTMEvent({
                networksocial: this.getName(button),
                actionsocial: this.getAction(button),
                targetsocial: this.getTarget(button),
                event: 'socialbutton'
            });
        });
    }

    sendGTMEvent(data) {
        if (window.dataLayer) {
            console.debug('Social event track ', data);
            window.dataLayer.push(data);
        }
    }

    // auxiliary
    getName(button) {
        return button.prop('class').match(/share-(\w+)-lnk/)[1];
    }

    getAction(button) {
        return {
            'share-site': 'perfil',
            'share-tool': 'compartir',
            'share-section': 'compartir',
            'share-aperture': 'compartir'
        } [this.share.has(button).prop('class')];
    }

    getTarget(button) {
        return button.prop('href');
    }
}
